import React from "react";
import isEmpty from "lodash/isEmpty";
import PropTypes from "prop-types";
import { Button } from "react-bootstrap";
import { REGEX } from "@dpdgroupuk/mydpd-enums";
import CodeButton from "../CodeButton";
import "./styles.scss";

const DataListItem = ({
  description,
  code,
  codeLength,
  applyCode,
  onCommodityCodeClick,
  onSubmit
}) => /*#__PURE__*/React.createElement("div", {
  className: "mydpd-commodity-data-item"
}, !isEmpty(description) && /*#__PURE__*/React.createElement("div", null, description.replace(REGEX.HTML_TAGS, "")), /*#__PURE__*/React.createElement("div", {
  className: "d-flex align-items-center mydpd-commodity-code-section"
}, /*#__PURE__*/React.createElement(CodeButton, {
  code: code,
  length: codeLength,
  onClick: () => onCommodityCodeClick(code),
  disabled: applyCode
}), applyCode && /*#__PURE__*/React.createElement(Button, {
  className: "mydpd-commodity-apply-button",
  onClick: () => onSubmit(code)
}, "Apply Code")));

DataListItem.propTypes = {
  description: PropTypes.string,
  code: PropTypes.string,
  codeLength: PropTypes.number,
  applyCode: PropTypes.bool,
  onCommodityCodeClick: PropTypes.func,
  onSubmit: PropTypes.func
};
export default DataListItem;